import React from 'react';
import { Container } from 'reactstrap';
import ToolsManageClientsPage from './components/ToolsManageClientsPage';

const ToolsManageClients = () => (
  <Container>
    <ToolsManageClientsPage />
  </Container>
);

export default ToolsManageClients;
